import { Box, Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { UserDetailMySelf } from "../userDetail/myself"
import { ActivityDescription } from "../activityDescription"
import { useEvidences } from "../../../../../../../hooks/evidences/useEvidences"
import { ActivityMap } from "../map"
import { ActivityDetailData } from "./types"
import { DetailHeader } from "../detailHeader"
import { loogbookServiceFetch } from "../../../../../../../utils/constants/callService"
import { useLocation } from "react-router-dom"
import { createRef, useEffect, useState } from "react"
import { useMenu } from "./utils/hooks/menu"
import { RequestErrors, Status, Types } from "../../../../../../../utils/enums"
import { FinishActivityBody, StartActivityBody } from "../../../../../../../service/logbook/body"
import useGeolocation from "../../../../../../../hooks/localization"
import { useTimeOut } from "../../../../../../../hooks/timeOut"
import { ModalType } from "../../../../../../../utils/types/generals"
import SimpleModal from "../../../../../../../components/modal/simpleModal"
import Loader from "../../../../../../../components/loader"
import { LoadingButton } from "@mui/lab"
import { CodeDeleteActivity, CodeFinishActivity, CodeStartActivity } from "../../../../../../../service/logbook/response"
import { SnackSimple } from "../../../../../../../components"
import { ConfirmActivityAction, MenuOptions } from "./utils/enums"
import { getLocalStorage, LocaleNameType } from "../../../../../../../utils/crud/crypt"
import { geoDistanceInMeters } from "../../../../../../../utils/methods/calcDistanceFromLatAndLong"
import { handleAllErrors } from "../../../../../../../utils/methods/handleErrors"
import { BaseMenuClick } from "../../../../../../../components/baseMenu"
import { CancelActivity } from "./components/cancelActivity"
import { CancelActivityRef } from "./components/cancelActivity/types"
import { ForceClosureActivity } from "./components/forceClosure"
import dayjs from "dayjs"
import { GetEvidencePayload } from "../detailHeader/types"
import { formatEvidencesToSendBody, formatEvidenceToUploadEvidence } from "../../../../../../../components/uploadEvidence/methods"
import { EvidenceActivityBody } from "../../../../../../../service/logbook/body/evidencesActivity"
import { useUploadEvidence } from "../../../../../../../components/uploadEvidence/hooks"
import { ReScheduleActivity } from "./components/reSchedule"
import { ReScheduleActivityRef } from "./components/reSchedule/types"
import { Constants } from "../../../../../../../utils/constants"
import { toUnitTimeZone } from "../../../../../../../utils/methods/calcDate"
import { ResendActivity } from "./components/resend"
import { ResendActivityRef } from "./components/resend/types"
import { CodeResendActivity } from "../../../../../../../service/logbook/response/resendActivity"
import { Hashs } from "../../activityRegister/utils"

export const ActivityDetail = () => {
    const cancelRef = createRef<CancelActivityRef>()
    const reAcheduleRef = createRef<ReScheduleActivityRef>()
    const resendRef = createRef<ResendActivityRef>()
    const branding = getLocalStorage<any>(LocaleNameType.SETTING)
    const { executeFunction } = useTimeOut()
    const [loadings, setLoadings] = useState({ footerButton: false, main: false })
    const { location: geoLocation, error } = useGeolocation()
    const [modal, setModal] = useState<ModalType>({ description: '', open: false, title: '' })
    const [snackbar, setSnackbar] = useState({
        open: false,
        type: Types.SUCCESS,
        message: '',
    })
    const [data, setData] = useState<ActivityDetailData>()
    const [flagClose, setFlagClose] = useState(false)
    const startDate = dayjs.utc(data?.startDate).format(Constants.dayjsFormat3)
    const validateDate = data?.startDate ? dayjs().isBefore(dayjs(startDate), 'seconds') : false 
    const evidenceUpload = useUploadEvidence()
    const { evidences, existEvidences, manageData } = useEvidences({ evidencesResponse: data?.evidence ?? [], manualValue: true })
    const menu = useMenu({ status: data?.header.status ?? Status.CANCEL, option: { canDelete: !!data?.isUserWithPermission, geofence: data?.geofence, locationOn: !error, isTheUserAssigned: data?.isTheUserAssigned } })
    const location = useLocation()
    const [_, activityId] = location.hash.split('-') ?? []
    const { t } = useTranslation()
    const styles = useStyles()

    const getActivity = async () => {
        evidenceUpload.setShowRequireds(false)
        setLoadings(prev => ({ ...prev, main: true }))
        const response = await loogbookServiceFetch.getActivityDetail(activityId)
        evidenceUpload.setEvidencesRequiredAreLoad(response.transform?.generalConfig?.requireList ?? {})
        setData(response.transform)
        manageData({ evidencesResponse: response.transform.evidence })
        setLoadings(prev => ({ ...prev, main: false }))
    }
    const deleteActivity = async () => {
        setModal(prev => ({
            ...prev,
            open: true,
            description: t('loogbook.modal.deleteActivity'),
            title: t('general.confirm'),
            confirm: async () => {
                setModal(prev => ({ ...prev, loading: true }))
                const response = await loogbookServiceFetch.deleteActivities(activityId)
                setModal(prev => ({ ...prev, loading: false }))
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    setFlagClose(true)
                    setModal({
                        title: t('loogbook.snackbar.deleteActivity.success'),
                        description: '',
                        open: true,
                        confirm: () => { window.location.hash = '' }
                    })
                    return
                } else {
                    setFlagClose(false)
                }
                setSnackbar({ message: t('loogbook.snackbar.deleteActivity.error'), open: true, type: Types.ERROR })
            },
            cancel: closeModal
        }))
    }
    const confirmCancel = async () => {
        if (cancelRef.current) {
            const reason = cancelRef.current?.getData?.reason?.trim()
            cancelRef.current.loading(true)
            if (!!reason) {
                const response = await loogbookServiceFetch.cancelActivities({ id: activityId, body: { closeMotive: reason, } })
                cancelRef.current.loading(false)
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    getActivity()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.cancelActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.cancelActivity.error'), open: true, type: Types.ERROR })
            }
        }
    }
    const confirmForcingClose = async () => {
        if (cancelRef.current) {
            const reason = cancelRef.current?.getData?.reason?.trim()
            cancelRef.current.loading(true)
            if (!!reason) {
                const userLat = geoLocation.lat?.toString() ?? ''
                const userLng = geoLocation.lng?.toString() ?? ''
                const response = await loogbookServiceFetch.forceActivities({
                    id: activityId, body: {
                        closeMotive: reason,
                        isMobile: false,
                        latitude: userLat,
                        longitude: userLng,
                        locationInitSiteName: data?.storePoint?.locationInitSiteName ?? ''
                    }
                })
                cancelRef.current.loading(false)
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    getActivity()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.forceActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.forceActivity.error'), open: true, type: Types.ERROR })
            }
        }
    }
    const confirmReSchedule = async () => {
        if (reAcheduleRef.current) {
            const dates = reAcheduleRef.current?.getData
            reAcheduleRef.current.loading(true)
            if (!!dates) {
                const response = await loogbookServiceFetch.reScheduleActivities({
                    id: activityId,
                    body: {
                        dateEnd: dayjs(dates.to).format(Constants.dayjsFormat3),
                        dateStart: dayjs(dates.from).format(Constants.dayjsFormat3),
                        ...(!!data?.timeZone?.id) && { timeZone: data?.timeZone?.id },
                    }
                })
                reAcheduleRef.current.loading(false)
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    getActivity()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.reScheduleActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: handleAllErrors(response.errors?.[0]?.code ?? RequestErrors.ERR_AUTH, t), open: true, type: Types.ERROR })
            }
        }
    }
    const confirmResend = async () => {
        if (resendRef.current) {
            const resendData = resendRef.current?.getData
            resendRef.current.loading(true)
            if (!!resendData) {
                const response = await loogbookServiceFetch.resendActivities({
                    body: {
                        external_emails: resendData.emails?.split(',').filter(email => !!email).map(email => email.trim()) ?? [],
                        user_ids: resendData.usersIds ?? [],
                        id: activityId,
                    }
                })
                resendRef.current.loading(false)
                if (response.code == CodeResendActivity.SUCCESS) {
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.resendActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.resendActivity.error'), open: true, type: Types.ERROR })
            }
        }
    }
    const cancelActivity = async () => {
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <CancelActivity
                    cancel={closeModal}
                    confirm={confirmCancel}
                    ref={cancelRef}
                />,
            description: t('general.cancelReason'),
            sx: styles.cancelStyles,
            title: t('general.cancelActivity'),
            confirmText: t('general.cancelActivity'),
        }))
    }
    const forceClosureActivity = async () => {
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <ForceClosureActivity
                    cancel={closeModal}
                    confirm={confirmForcingClose}
                    ref={cancelRef}
                />,
            description:isIntoTheRange().intoRange ? t('general.forcingDescriptionIntoRange') : t('general.forcingDescriptionOutRange'),
            sx: styles.cancelStyles,
            title: t('general.forcingClosure'),
            confirmText: t('general.cancelActivity'),
        }))
    }
    const reScheduleActivity = async () => {
        const isValidatedStartDate = dayjs().isAfter(data?.startDate)
        const isValidatedEndDate = dayjs().isAfter(data?.endDate)
        const dateStart = data?.startDate ? dayjs(data?.startDate) : dayjs()
        const dateEnd = data?.endDate ? dayjs(data?.endDate) : null
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <ReScheduleActivity
                    timeZone={data?.timeZone}
                    defaultDate={{
                        from: isValidatedStartDate ? dayjs(toUnitTimeZone(new Date(), data?.timeZone.value)) : dateStart,
                        to: isValidatedEndDate ? null : dateEnd,
                    }}
                    cancel={closeModal}
                    confirm={confirmReSchedule}
                    ref={reAcheduleRef}
                />,
            description: '',
            sx: styles.cancelStyles,
            title: t('loogbook.reScheduleActivity'),
            confirmText: t('general.reSchedule'),
        }))
    }
    const resendActivity = async () => {
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <ResendActivity
                    timeZone={data?.timeZone}
                    cancel={closeModal}
                    confirm={confirmResend}
                    ref={resendRef}
                />,
            description: '',
            sx: styles.cancelStyles,
            title: t('general.resendReport'),
            confirmText: t('general.reSchedule'),
        }))
    }
    const seeInform = async () => {
        setSnackbar({ message: t('loogbook.snackbar.loadingReport'), open: true, type: Types.INFO })
        const response = await loogbookServiceFetch.seeInform({ id: Number(activityId) })

        if(response.errors){
            setSnackbar({ message: t('loogbook.snackbar.seeInform.error'), open: true, type: Types.ERROR })
        }else{
            window.open(response.reportUrl, '_blank');
        }
        
    }
    const isIntoTheRange = () => {
        const fence: number = branding?.brandy?.configLocations?.digitalFenceMts ?? 0
        
        if (!data?.geofence || !fence) {
            return { intoRange: true }
        }

        const userLat = geoLocation.lat?.toString() ?? ''
        const userLng = geoLocation.lng?.toString() ?? ''
        if (data?.storePoint) {
            const meters = Math.abs(Number(geoDistanceInMeters({ from: { lat: userLat, lng: userLng }, to: { lat: data?.storePoint.lat, lng: data?.storePoint.lng } })) ?? 0)
            const intoRange = fence >= meters
            if (!intoRange) {
                setSnackbar({ open: true, message: t('loogbook.snackbar.range.youAreOutside'), type: Types.ERROR })
            }
            return { intoRange }
        }

        setSnackbar({ open: true, message: t('loogbook.snackbar.range.thereNoRange'), type: Types.ERROR })
        return { intoRange: true, thereNoLocation: true }
    }
    const startActivity = async () => {
        if (validateDate) {
            setSnackbar({ open: true, message: t('loogbook.snackbar.startActivity.pastDate'), type: Types.ERROR })
            return
        }
        loadingModal(true)
        setLoadings(prev => ({ ...prev, footerButton: true }))
        const userLat = geoLocation.lat?.toString() ?? ''
        const userLng = geoLocation.lng?.toString() ?? ''
        const body: StartActivityBody = {
            isMobile: false,
            latitude: userLat,
            longitude: userLng
        }
        const validateRange = isIntoTheRange()
        if (validateRange.intoRange) {
            const response = await loogbookServiceFetch.startActivity({ id: activityId, body })
            setLoadings(prev => ({ ...prev, footerButton: false }))
            loadingModal(false)
            if (response.code == CodeStartActivity.SUCCESS) {
                getActivity()
                setSnackbar({ open: true, message: t('loogbook.snackbar.startActivity.success'), type: Types.SUCCESS })
                closeModal()
                return
            }
            setSnackbar({ open: true, message: handleAllErrors(response?.errors?.[0]?.code, t, 'loogbook.snackbar.startActivity.error'), type: Types.ERROR })
            return
        }else{
            setLoadings(prev => ({ ...prev, footerButton: false }))
            loadingModal(false)
            setSnackbar({ open: true, message: t('loogbook.modal.startActivityOutRange'), type: Types.ERROR })
        }
    }
    const finishActivity = async () => {
        const someIsRequired = evidenceUpload.someEvidenceIsRequired()
        if (someIsRequired) {
            evidenceUpload.setShowRequireds(true)
            setSnackbar({ message: t('loogbook.snackbar.requiredFields'), open: true, type: Types.ERROR })
            closeModal()
            return
        }
        loadingModal(true)
        setLoadings(prev => ({ ...prev, footerButton: true }))
        const body: FinishActivityBody = {
            isMobile: false,
            latitude: geoLocation.lat?.toString() ?? '',
            longitude: geoLocation.lng?.toString() ?? ''
        }
        const validateRange = isIntoTheRange()
        if (validateRange.intoRange) {
            const response = await loogbookServiceFetch.finsihActivity({ id: activityId, body })
            setLoadings(prev => ({ ...prev, footerButton: false }))
            loadingModal(false)
            if (response.code == CodeFinishActivity.SUCCESS) {
                getActivity()
                setSnackbar({ open: true, message: t('loogbook.snackbar.finishActivity.success'), type: Types.SUCCESS })
                closeModal()
                return
            }
            setSnackbar({ open: true, message: handleAllErrors(response?.errors?.[0]?.code, t, 'loogbook.snackbar.finishActivity.error'), type: Types.ERROR })
        }else{
            setLoadings(prev => ({ ...prev, footerButton: false }))
            loadingModal(false)
            setSnackbar({ open: true, message: t('loogbook.modal.finishActivityOutRange'), type: Types.ERROR })
        }
    }

    const menuOption: BaseMenuClick = ({ value }) => {
        switch (value) {
            case MenuOptions.EDIT: {
                window.location.hash = `${Hashs.EDIT}-${activityId}`
                break
            }
            case MenuOptions.DELETE: {
                deleteActivity()
                break
            }
            case MenuOptions.CANCEL_ACTIVITY: {
                cancelActivity()
                break
            }
            case MenuOptions.FORCE_CLOSURE: {
                forceClosureActivity()
                break
            }
            case MenuOptions.RESCHEDULE: {
                reScheduleActivity()
                break
            }
            case MenuOptions.RESEND_INFORM: {
                resendActivity()
                break
            }
            case MenuOptions.SEE_INFORM: {
                seeInform()
                break
            }
        }
    }

    const submitEvidences = async ({ evidences }: GetEvidencePayload) => {
        const thereAreSomeChange = evidenceUpload.hasAnyValueChanged()
        if (!thereAreSomeChange) {
            setSnackbar({ message: t('loogbook.snackbar.thereAreNotSomeChange'), open: true, type: Types.ERROR })
            return
        }
        if (!!thereAreSomeChange) {
            const convert = formatEvidencesToSendBody({ evidences })
            const body: EvidenceActivityBody = {
                ...convert,
                id: activityId
            }
            const response = await loogbookServiceFetch.evidencesActivity({ body })
            if (!response.errors) {
                getActivity()
                evidenceUpload.deleteListOfFiles()
                closeModal()
                setSnackbar({ message: t('loogbook.snackbar.evidenceActivity.success'), open: true, type: Types.SUCCESS })
                return
            }
            setSnackbar({ message: handleAllErrors(response?.errors?.[0]?.code, t, 'loogbook.snackbar.evidenceActivity.error'), open: true, type: Types.ERROR })
        }
    }
    const closeSnackbar = () => {
        setSnackbar(prev => ({ ...prev, open: false }))
    }
    const loadingModal = (value: boolean) => {
        setModal(prev => ({ ...prev, loading: value }))
    }
    const closeModal = () => {
        setModal({ description: '', open: false, title: '' })
        if(flagClose){
            window.location.hash = ''
        }
    }
    const confirmActiveOrFinish = ({ action }: { action: ConfirmActivityAction }) => {
        let title = ''
        let confirm = () => { }
        switch (action) {
            case ConfirmActivityAction.START: {
                title = t('loogbook.modal.start.title')
                confirm = startActivity
                break
            }
            case ConfirmActivityAction.FINISH: {
                title = t('loogbook.modal.finish.title')
                confirm = finishActivity
                break
            }
        }
        setModal(prev => ({
            ...prev,
            open: true,
            title: title,
            confirm,
            cancel: closeModal
        }))
    }
    useEffect(() => {
        getActivity()
    }, [location.hash])

    useEffect(()=>{
        const response = formatEvidenceToUploadEvidence({ evidenceConfig: data?.generalConfig?.evidence, evidencesDetail: evidences })
        evidenceUpload.defaultEvidence({ evidencesConfig: response, requireList: data?.generalConfig?.requireList })
    },[data])

    useEffect(() => {
        executeFunction({
            execute: () => {
                if (error && [Status.TO_BE_STARTED, Status.STARTED].includes(data?.header.status ?? Status.ACTIVE)) {
                    setModal(prev => ({
                        ...prev,
                        open: true,
                        title: data?.header.status == Status.TO_BE_STARTED ? t('loogbook.modal.startActivity') : t('loogbook.modal.finishActivity')
                    }))
                }
            }
        })
    }, [error, data?.header.status])
    if (loadings.main) { return <Loader /> }
    return (
        <>
            <Grid container spacing={3} sx={styles.gridContainer}>
                <Grid item xl={7} lg={7} xs={6}>
                    <Box sx={styles.container}>
                        <Box sx={styles.detail}>
                            <DetailHeader
                                {...data?.header}
                                evidenceUpload={evidenceUpload}
                                isUserWithPermission={!!data?.isUserWithPermission}
                                activityId={activityId}
                                evidences={evidences}
                                existEvidences={existEvidences}
                                evidenceConfig={data?.generalConfig}
                                getEvidence={submitEvidences}
                                menu={{
                                    menuItems: menu,
                                    click: menuOption
                                }}
                            />

                            <Box>
                                <Typography variant="text_grey" fontWeight='bold'>{t('general.assignedUser')}</Typography>

                                <UserDetailMySelf {...data?.assignedUser} />
                            </Box>

                            <ActivityDescription {...data?.description} />
                        </Box>

                        {!!data?.isTheUserAssigned && (
                            <Box sx={styles.btnFooter}>
                                {(data?.header.status == Status.TO_BE_STARTED && !error && !validateDate) && <LoadingButton loading={loadings.footerButton} onClick={() => { confirmActiveOrFinish({ action: ConfirmActivityAction.START }) }} variant="primary_c">{t('loogbook.startActivity')}</LoadingButton>}
                                {(data?.header.status == Status.STARTED && !error) && <LoadingButton loading={loadings.footerButton} onClick={() => { confirmActiveOrFinish({ action: ConfirmActivityAction.FINISH }) }} variant="primary_c">{t('loogbook.finishActivity')}</LoadingButton>}
                            </Box>
                        )}
                    </Box>
                </Grid>

                <Grid item xl={5} lg={5} xs={6}>
                    <Box sx={styles.map}>
                        <Typography variant="text_grey" color='primary.100' fontWeight='bold'>{t('loogbook.titles.activityTour')}</Typography>

                        <ActivityMap hiddenUsers={[]} usersMark={data?.mark ?? []} loadings={{ left: false, right: false }} />
                    </Box>
                </Grid>
            </Grid>

            <SimpleModal
                sx={modal.sx}
                open={!!modal.open}
                close={modal.cancel ?? closeModal}
                title={modal.title}
                children={modal.children}
                removeButtons={modal.removeButtons}
                isLoading={!!modal?.loading}
                loadingButton={!!modal?.loading}
                description={modal.description}
                cancelText={modal.cancelText ?? t('general.cancel')}
                buttonText={modal?.confirmText ?? t('general.confirm')}
                back={modal.cancel}
                next={modal?.confirm ?? closeModal}
            />
            <SnackSimple close={closeSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />
        </>
    )
}